import { QAPairSupportMessageTypes } from './useQAPair';
import { toNumber } from 'lodash-es';

export const isInQaPairMsgRang = (
  msg: Conversation.Message,
  knowledgeQuery?: Conversation.Message,
) => {
  if (!knowledgeQuery) {
    return false;
  }
  const targetTime = knowledgeQuery.sendTime;

  const { sendTime, msgFromType, isFromOfficial, isAutoReply, messageType } = msg;

  return (
    msgFromType === 'ASSISTANT' &&
    QAPairSupportMessageTypes.includes(messageType) &&
    !isFromOfficial &&
    !isAutoReply &&
    toNumber(sendTime) > toNumber(targetTime)
  );
};

export const isInQAPairMessageType = (msg: Conversation.Message) => {
  const { msgFromType, isFromOfficial, isAutoReply, messageType } = msg;

  return (
    msgFromType === 'ASSISTANT' &&
    QAPairSupportMessageTypes.includes(messageType) &&
    !isFromOfficial &&
    !isAutoReply
  );
};
